// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-layout-TabView-TabView-module__container-Ll1Dq8","tab":"src-app-components-layout-TabView-TabView-module__tab-YGCExx","active":"src-app-components-layout-TabView-TabView-module__active-QseM1R","tab__cover":"src-app-components-layout-TabView-TabView-module__tab__cover-jNFIdO","tabCover":"src-app-components-layout-TabView-TabView-module__tab__cover-jNFIdO","close":"src-app-components-layout-TabView-TabView-module__close-n35VoT"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-layout-TabView-TabView-module__container-Ll1Dq8\",\"tab\":\"src-app-components-layout-TabView-TabView-module__tab-YGCExx\",\"active\":\"src-app-components-layout-TabView-TabView-module__active-QseM1R\",\"tab__cover\":\"src-app-components-layout-TabView-TabView-module__tab__cover-jNFIdO\",\"tabCover\":\"src-app-components-layout-TabView-TabView-module__tab__cover-jNFIdO\",\"close\":\"src-app-components-layout-TabView-TabView-module__close-n35VoT\"}";
        // 1789362522807
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  